<template> 
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="signOut()" class="power">
      <i style="cursor: pointer; font-size: 0.5rem" class="el-icon-back"></i>
    </div>
    <div class="otherReport">
      <!-- <img @click="d8Process()" style="height: 0.8rem" src="../../../assets/img/fr/table.png" /> -->
    </div>
    <div class="sourceOtherTime">
      <span style="margin-top:5px;">更新时间：{{ updateTimeText }}</span>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <div class="prductCategory">
      <el-dropdown @command="selectProduct" trigger="click">
        <span style="color: white" class="el-dropdown-link">
          过程分类：{{ product["uuid"] ? product["title"] : "所有分类"
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="''">所有分类</el-dropdown-item>
          <el-dropdown-item :command="item" v-for="(item, i) in productList" :key="i">{{ item.title }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <h3 class="title">快速反应跟踪</h3> -->
      <!--  <el-button class="title" type="primary">{{ title }}</el-button> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "统计看板" }}
      </div>
    </header>
    <div style="height: 100vh;width:100%">
      <el-row :gutter="0">
        <el-col :span="8" v-for="(item, index) in issueRateList" :key="index">
          <div style="height: 40vh">
            <!--根据 issueRateList 循环显示-->
            <fr-source-attend :beans="item.monthList" :title="item.sourceTitle" :chartId="'chart-' + index"></fr-source-attend>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template> 

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../../router";
import format from "date-fns/format";
import frSourceAttend from "./component/month-attend-rate.vue";
export default {
  name: "App",
  components: {
    frSourceAttend
  },
  data() {
    return {
      websock: null,
      lockReconnect: false,
      reconnectData: null,
      isload: false,
      issueRateList: [], //问题关闭率
      issueDeptList: [], //责任部门问题
      issueSource: [], //问题来源
      monthAttend: [], //月度出勤
      deptAttend: [], //部门出勤
      issueList: [], //未关闭问题列表
      programRateList: [],//项目
      supplierRateList: [],//供应商
      causeRateList: [],//根本原因
      now: null,
      week: null,
      loading: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "问题来源统计",
      productList: [],
      product: {},
      productUUID: null,
      updateTimeText:null,
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
     this.loadProductLine();
    //钟表
    setInterval(this.clock, 1000);
  },
  created() {
    this.isload = true;
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    signOut() {
      router.back();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        const params = {
          Expanded: "",
          Selectable: ""
        };
        API.listTree(params)
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadTemplateCategory() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadTemplateCategory()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },
    selectProduct(item) {
      console.log(item);
      this.product = item || {};
      this.productUUID = item ? item.uuid : null;
      this.isload = true;
      this.loadData();
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        this.startLoading();
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = { processCategory: this.product["uuid"] };

        API.getFrSourceDataV(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.issueRateList = res["list"];
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
            this.endLoading();
          })
          .catch((error) => {
            console.log(error);
            this.endLoading();
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("分层审核 socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("分层审核 socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("分层审核 socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 20px;
  z-index: 999999;
}

.pagebg {
  background: url("../../../../assets/img/8dbg.png");
}

.p {
  padding: .13333rem;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
.prductCategory {
  color: white;
  position: absolute;
  right: 10%;
  top: 20px;
  z-index: 999999;
}
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>
<style scoped src='./board.css'></style>


// WEBPACK FOOTER //
// src/pages/fr/report/source/board.vue